import React from 'react';

const Meta: React.SFC<MetaProps> = ({ title, info, ...args }) => (
  <div className="meta" {...args}>
    <h3 className="meta__title">
      {title}
    </h3>
    <div className="meta__info">
      {info}
    </div>
  </div>
);

export interface MetaProps {
  title: string;
  info: string;
}

export default Meta;
